import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { FileTypeSelectComponent } from "./FileTypeSelectComponent";

interface FileTypeSelectProps {
  aiFileDownloadUrl: string;
  name: string;
  rules: RegisterOptions;
  supportsAi: boolean;
}

export const FileTypeSelect = ({
  name,
  rules,
  supportsAi,
  aiFileDownloadUrl,
}: FileTypeSelectProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <FileTypeSelectComponent
          onChange={onChange}
          value={value}
          supportsAi={supportsAi}
          aiFileDownloadUrl={aiFileDownloadUrl}
        />
      )}
    />
  );
};
